/** The X handle a player types for the leaderboard — the same rule as the server's clean_handle (api/solrun.py).
 *  No sign-in (Karolis 2026-10-16): the player types "@name", "name" or pastes their profile link; the board links it to x.com. */

const HANDLE = /^[A-Za-z0-9_]{1,15}$/;
/** x.com/<these> are X's own pages, not profiles */
const NOT_HANDLES = new Set(["home", "explore", "notifications", "messages", "settings", "search", "i", "compose", "login", "logout",
  "signup", "tos", "privacy", "intent", "share", "hashtag"]);
const LINK = /^(?:https?:\/\/)?(?:www\.|mobile\.)?(?:x|twitter)\.com\/([^/?#\s]+)/i;

/** "@name" / "name" / "https://x.com/name?s=20" → "name"; undefined when it can't be an X handle. */
export function cleanHandle(raw: string | undefined | null): string | undefined {
  let text = String(raw ?? "").trim();
  const link = LINK.exec(text);
  if (link) text = link[1];
  if (text.startsWith("@")) text = text.slice(1);
  return HANDLE.test(text) && !NOT_HANDLES.has(text.toLowerCase()) ? text : undefined;
}

/** The player's profile on X (the handle is already clean: letters, digits and "_" only). */
export function profileUrl(handle: string): string {
  return `https://x.com/${encodeURIComponent(handle)}`;
}
